var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "m-subheader" }, [
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c("div", { staticClass: "mr-auto" }, [
            _c(
              "ul",
              { staticClass: "m-subheader__breadcrumbs m-nav m-nav--inline" },
              [
                _c(
                  "li",
                  { staticClass: "m-nav__item" },
                  [
                    _c("router-link", { attrs: { to: { name: "home" } } }, [
                      _c("span", { staticClass: "m-nav__link-text" }, [
                        _c("i", { staticClass: "m-nav__link-icon la la-home" })
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", { staticClass: "m-nav__separator" }, [
                  _vm._v("\n\t\t  \t  \t\t>\n\t\t  \t  \t")
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "m-nav__item" }, [
                  _c("span", { staticClass: "m-nav__link-text" }, [
                    _vm._v(
                      "\n\t\t  \t  \t\t\t" +
                        _vm._s(
                          _vm._f("titleize")(
                            _vm._f("translate")("search_for_visitors")
                          )
                        ) +
                        "\n\t\t  \t  \t\t"
                    )
                  ])
                ])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "m-content" }, [
        _c("div", { staticClass: "m-portlet m-portlet--tab" }, [
          _c("div", { staticClass: "m-portlet__head" }, [
            _c("div", { staticClass: "m-portlet__head-caption" }, [
              _c("div", { staticClass: "m-portlet__head-title" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("h3", { staticClass: "m-portlet__head-text" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm._f("titleize")(
                          _vm._f("translate")("search_for_visitors")
                        )
                      ) +
                      "\n              "
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "m-form m-form--state",
              attrs: { "data-vv-scope": "searh_form" }
            },
            [
              _c("div", { staticClass: "m-portlet__body" }, [
                _c("div", { staticClass: "form-group m-form__group row" }, [
                  _c("div", { staticClass: "col-lg-4 pb-3" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("select_search_type")
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.search_type,
                            expression: "search_type"
                          }
                        ],
                        staticClass:
                          "form-control m-bootstrap-select m_selectpicker",
                        attrs: { id: "select_search_type" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.search_type = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      _vm._l(_vm.search_options, function(option, idx) {
                        return _c(
                          "option",
                          { key: idx, domProps: { value: option.value } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")(option.name)
                                )
                              )
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.refreshSelector("select_search_type")) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.search_type === 3
                    ? _c(
                        "div",
                        {
                          class: [
                            {
                              "has-danger": _vm.errors.has(
                                "searh_form.select_credential_type"
                              )
                            },
                            "col-lg-3"
                          ]
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm._f("capitalize")("select_credential"))
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.credential_type,
                                  expression: "credential_type"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass:
                                "form-control m-bootstrap-select m_selectpicker",
                              attrs: {
                                id: "select_credential_type",
                                "data-vv-as": "select_credential_type",
                                name: "select_credential_type"
                              },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.credential_type = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("capitalize")("select_an_option")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.credential_list, function(
                                credential,
                                idx
                              ) {
                                return _c(
                                  "option",
                                  {
                                    key: idx,
                                    domProps: { value: credential.id }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("capitalize")(
                                          _vm._f("translate")(
                                            credential.description
                                          )
                                        )
                                      )
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          ),
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.refreshSelector("select_credential_type")
                              ) +
                              "\n                "
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has(
                                    "searh_form.select_credential_type"
                                  ),
                                  expression:
                                    "errors.has(`searh_form.select_credential_type`)"
                                }
                              ],
                              staticClass: "m-form__help m--font-danger"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.errors.first(
                                      "searh_form.select_credential_type"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: [
                        {
                          "has-danger": _vm.errors.has("searh_form.enter_value")
                        },
                        _vm.search_type === 3 ? "col-lg-3" : "col-lg-6"
                      ]
                    },
                    [
                      _c("label", { attrs: { for: "enter_value" } }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("capitalize")(
                              _vm._f("translate")("enter_value")
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.search_value,
                            expression: "search_value"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value:
                              _vm.search_type == 0
                                ? "required|alpha_num|min:3"
                                : _vm.search_type == 1
                                ? {
                                    required: true,
                                    min: 3,
                                    regex: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜÑ\s]*$/i
                                  }
                                : "required",
                            expression:
                              "search_type == 0 ? 'required|alpha_num|min:3' : search_type == 1 ? { required: true, min:3, regex:/^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜÑ\\s]*$/i } : 'required'"
                          }
                        ],
                        ref: "id_num",
                        staticClass: "form-control m-input",
                        attrs: {
                          "data-vv-as": _vm._f("translate")("enter_value"),
                          type: "text",
                          name: "enter_value",
                          autofocus: ""
                        },
                        domProps: { value: _vm.search_value },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.search_value = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("searh_form.enter_value"),
                              expression: "errors.has(`searh_form.enter_value`)"
                            }
                          ],
                          staticClass: "m-form__help m--font-danger"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.errors.first("searh_form.enter_value")
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.search_type === 3,
                          expression: "search_type === 3"
                        }
                      ],
                      class: [
                        {
                          "has-danger": _vm.errors.has(
                            "searh_form.facility_code"
                          )
                        },
                        "col-lg-2"
                      ]
                    },
                    [
                      _c("label", { attrs: { for: "facility_code" } }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("capitalize")(
                              _vm._f("translate")("facility_code")
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.search_value_facility,
                            expression: "search_value_facility"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "alpha_num",
                            expression: "'alpha_num'"
                          }
                        ],
                        ref: "facility_code",
                        staticClass: "form-control m-input",
                        attrs: {
                          "data-vv-as": _vm._f("translate")("facility_code"),
                          type: "text",
                          name: "facility_code",
                          autofocus: ""
                        },
                        domProps: { value: _vm.search_value_facility },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.search_value_facility = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("searh_form.facility_code"),
                              expression:
                                "errors.has(`searh_form.facility_code`)"
                            }
                          ],
                          staticClass: "m-form__help m--font-danger"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.errors.first("searh_form.facility_code")
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-2" }, [
                    _c("label", [_vm._v(" ")]),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "tab",
                                9,
                                $event.key,
                                "Tab"
                              )
                            ) {
                              return null
                            }
                            return _vm.disable()
                          },
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.searchPerson.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("translate")("search")
                              )
                            ) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-danger",
                        attrs: { href: "" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.cancelSearch()
                          }
                        }
                      },
                      [_c("i", { staticClass: "la la-trash" })]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.singular,
                        expression: "!singular"
                      }
                    ],
                    staticClass: "m-portlet m-portlet--tab"
                  },
                  [
                    _c("s-datatable", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            (_vm.data_search.length > 0 &&
                              _vm.show_datatable) ||
                            (_vm.show_datatable && !_vm.validPermission(4407)),
                          expression:
                            "data_search.length > 0 && show_datatable || show_datatable && !validPermission(4407)"
                        }
                      ],
                      attrs: { config: _vm.datatable },
                      on: {
                        data: function($event) {
                          _vm.data_search = $event
                        },
                        final_query: function($event) {
                          _vm.show_datatable = $event
                        }
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "actions",
                          fn: function(props) {
                            return _c("div", {}, [
                              props.row.authorizations_reception.length > 0
                                ? _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: _vm.messageDetailTooltip,
                                          expression: "messageDetailTooltip"
                                        }
                                      ],
                                      staticClass:
                                        "m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_edit",
                                      on: {
                                        click: function($event) {
                                          return _vm.showPerson(
                                            props.row.id,
                                            props.row.person_novelty
                                          )
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "la la-eye" })]
                                  )
                                : _vm.validateBlockade(
                                    _vm.today,
                                    props.row.person_novelty
                                  )
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-pill badge-danger"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm._f("capitalize")(
                                              _vm._f("translate")(
                                                "person_blocked"
                                              )
                                            )
                                          ) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                : _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-brand btn-sm m-btn m-btn--pill m-btn--wide",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.goToAuthorization()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm._f("capitalize")(
                                              _vm._f("translate")("authorize")
                                            )
                                          ) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                            ])
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          (_vm.data_search.length === 0 || _vm.create_autho) &&
                          _vm.show_datatable &&
                          _vm.validPermission(4407),
                        expression:
                          "(data_search.length === 0 || create_autho)  && show_datatable && validPermission(4407)"
                      }
                    ],
                    staticClass:
                      "m-alert m-alert--icon m-alert--outline alert alert-primary",
                    attrs: { role: "alert" }
                  },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", { staticClass: "m-alert__text" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("capitalize")(
                              _vm._f("translate")("authorization_not_found")
                            )
                          ) +
                          ",\n                "
                      ),
                      _c(
                        "strong",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.search_type === 0,
                              expression: "search_type === 0"
                            }
                          ]
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("translate")("authorization_question")
                              )
                            )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.search_type === 0 && !_vm.person_blocked,
                            expression: "search_type === 0 && !person_blocked"
                          }
                        ],
                        staticClass: "m-alert__actions",
                        staticStyle: { width: "200px" }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-brand btn-sm m-btn m-btn--pill m-btn--wide",
                            attrs: {
                              type: "button",
                              disabled: !_vm.allow_create_authorizations
                            },
                            on: {
                              click: function($event) {
                                return _vm.goToAuthorization()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm._f("translate")("authorize")
                                  )
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _vm.searched && _vm.singular && _vm.belongs_to_company
          ? _c("div", { staticClass: "m-portlet m-portlet--tab" }, [
              _c("div", { staticClass: "m-portlet__head" }, [
                _c("div", { staticClass: "m-portlet__head-caption" }, [
                  _c("div", { staticClass: "m-portlet__head-title" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c(
                      "h3",
                      { ref: "info_div", staticClass: "m-portlet__head-text" },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm._f("titleize")(
                                _vm._f("translate")("general_info")
                              )
                            ) +
                            "\n              "
                        )
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "m-portlet__body break-world" }, [
                !_vm.hide_person_data
                  ? _c("div", { staticClass: "form-group m-form__group row" }, [
                      _vm.is_photo_auth === "true"
                        ? _c("div", { staticClass: "col-lg-2 pb-2" }, [
                            _c("figure", { staticClass: "figure" }, [
                              _c("img", {
                                staticClass: "img-thumbnail img-web-w min-150",
                                attrs: { src: _vm.person_info.image }
                              })
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class:
                            _vm.is_photo_auth === "true"
                              ? "col-lg-10 pb-3"
                              : "col-lg-12 pb-3"
                        },
                        [
                          !_vm.hide_person_data
                            ? _c(
                                "div",
                                { staticClass: "form-group m-form__group row" },
                                [
                                  _c(
                                    "div",
                                    {
                                      class:
                                        _vm.is_photo_auth === "true"
                                          ? "col-lg-4 pb-3"
                                          : "col-lg-3 pb-3"
                                    },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("capitalize")(
                                              _vm._f("translate")(
                                                "identification_number"
                                              )
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("input", {
                                        staticClass: "form-control m-input",
                                        attrs: { type: "text", readonly: "" },
                                        domProps: {
                                          value:
                                            _vm.person_info.identification_types
                                              .abbreviation +
                                            " " +
                                            _vm.person_info
                                              .identification_number
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      class:
                                        _vm.is_photo_auth === "true"
                                          ? "col-lg-4 pb-3"
                                          : "col-lg-3 pb-3"
                                    },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("capitalize")(
                                              _vm._f("translate")("first_names")
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.person_info.first_name,
                                            expression: "person_info.first_name"
                                          }
                                        ],
                                        staticClass: "form-control m-input",
                                        attrs: { type: "text", readonly: "" },
                                        domProps: {
                                          value: _vm.person_info.first_name
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.person_info,
                                              "first_name",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      class:
                                        _vm.is_photo_auth === "true"
                                          ? "col-lg-4 pb-3"
                                          : "col-lg-3 pb-3"
                                    },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("capitalize")(
                                              _vm._f("translate")("last_names")
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.person_info.last_name,
                                            expression: "person_info.last_name"
                                          }
                                        ],
                                        staticClass: "form-control m-input",
                                        attrs: { type: "text", readonly: "" },
                                        domProps: {
                                          value: _vm.person_info.last_name
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.person_info,
                                              "last_name",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      class:
                                        _vm.is_photo_auth === "true"
                                          ? "col-lg-4 pb-3"
                                          : "col-lg-3 pb-3"
                                    },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("capitalize")(
                                              _vm._f("translate")("email")
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.person_info.email,
                                            expression: "person_info.email"
                                          }
                                        ],
                                        staticClass: "form-control m-input",
                                        attrs: { type: "text", readonly: "" },
                                        domProps: {
                                          value: _vm.person_info.email
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.person_info,
                                              "email",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  ),
                                  _c("br"),
                                  _c("br")
                                ]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _vm.searched &&
                      _vm.move_record == "true" &&
                      _vm.validPermission(1407)
                        ? _c("div", { staticClass: "col-lg-12 center-text" }, [
                            _c(
                              "button",
                              {
                                ref: "move_button",
                                staticClass: "btn btn-primary",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.recMovement()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm._f("translate")(_vm.text_button)
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("br"),
                      _c("br")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { attrs: { id: "authorizations_accordion" } },
                  _vm._l(_vm.person_info.authorizations_reception, function(
                    authorization,
                    index
                  ) {
                    return _vm.validCompany(authorization.company.id)
                      ? _c("div", { key: index, staticClass: "card" }, [
                          _c(
                            "div",
                            {
                              staticClass: "card-header cursor-pointer",
                              attrs: {
                                "data-parent": "#authorizations_accordion",
                                id: "heading_" + index,
                                "data-toggle": "collapse",
                                "data-target": "#expiration_documents_" + index,
                                "aria-expanded":
                                  _vm.person_info.authorizations_reception
                                    .length == 1
                                    ? true
                                    : false,
                                "aria-controls": "expiration_documents_" + index
                              }
                            },
                            [
                              _c("p", { staticClass: "mb-0 card_title" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm._f("translate")("authorization_as")
                                      )
                                    ) +
                                    " "
                                ),
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      authorization.access_profile.authorized_type.name.toUpperCase()
                                    )
                                  )
                                ]),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm._f("translate")("for_company")) +
                                    " "
                                ),
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      authorization.company.name.toUpperCase()
                                    )
                                  )
                                ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "collapse",
                              class: {
                                show:
                                  _vm.person_info.authorizations_reception
                                    .length == 1 ||
                                  _vm.current_company_type !== _vm.admin_company
                              },
                              attrs: {
                                id: "expiration_documents_" + index,
                                "aria-labelledby": "heading_" + index
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "card-body" },
                                [
                                  _vm.preautorization === 2
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "m-alert m-alert--icon m-alert--outline alert alert-warning",
                                          attrs: { role: "alert" }
                                        },
                                        [
                                          _vm._m(3, true),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "m-alert__text" },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("capitalize")(
                                                      "pending_pre_authorization"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.preautorization === 3
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "m-alert m-alert--icon m-alert--outline alert alert-danger",
                                          attrs: { role: "alert" }
                                        },
                                        [
                                          _vm._m(4, true),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "m-alert__text" },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("capitalize")(
                                                      "refused_pre_authorization"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.validate_training[index] > 0 &&
                                  _vm.validate_covid &&
                                  _vm.prop_training === "true"
                                    ? _c(
                                        "div",
                                        {
                                          key: _vm.refreshCount,
                                          staticClass:
                                            "m-alert m-alert--icon m-alert--outline alert alert-danger",
                                          attrs: { role: "alert" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.change_active_autho_status(
                                                  index
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                          _vm._m(5, true),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "m-alert__text" },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("capitalize")(
                                                      "training_missing"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _c("br")
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.validate_training[index] > 0 &&
                                  _vm.validate_covid &&
                                  _vm.prop_training === "false"
                                    ? _c(
                                        "div",
                                        {
                                          key: _vm.refreshCount,
                                          staticClass:
                                            "m-alert m-alert--icon m-alert--outline alert alert-warning",
                                          attrs: { role: "alert" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.change_active_autho_status(
                                                  index
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                          _vm._m(6, true),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "m-alert__text" },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("capitalize")(
                                                      "pending_training"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _c("br")
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hourToSeconds(_vm.time_property) <
                                    _vm.hourToSeconds(
                                      authorization.access_profile.start_time
                                    ) ||
                                  _vm.hourToSeconds(_vm.time_property) >
                                    _vm.hourToSeconds(
                                      authorization.access_profile.end_time
                                    )
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "m-alert m-alert--icon m-alert--outline alert alert-warning",
                                          attrs: { role: "alert" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.change_active_autho_status(
                                                  index
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                          _vm._m(7, true),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "m-alert__text" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("capitalize")(
                                                      _vm._f("translate")(
                                                        "authorization_out_of_time"
                                                      )
                                                    )
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(_vm.documents_validated, function(
                                    document_valid,
                                    item
                                  ) {
                                    return _vm.documents_validated.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            key: item,
                                            staticClass:
                                              "m-alert m-alert--icon m-alert--outline alert alert-danger",
                                            attrs: { role: "alert" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.change_active_autho_status(
                                                    index
                                                  )
                                                ) +
                                                "\n                    "
                                            ),
                                            _vm._m(8, true),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "m-alert__text" },
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("capitalize")(
                                                        "expired_document"
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _c("br"),
                                                _vm._v(" "),
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      document_valid.name +
                                                        ": " +
                                                        document_valid.value
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  }),
                                  _vm._v(" "),
                                  _vm.validate_access_day[index]
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "m-alert m-alert--icon m-alert--outline alert alert-danger",
                                          attrs: { role: "alert" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.change_active_autho_status(
                                                  index
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                          _vm._m(9, true),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "m-alert__text" },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm._f("capitalize")(
                                                      "cannot_access_today"
                                                    )
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      _vm.day_name
                                                    )
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.validate_end_date[index]
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "m-alert m-alert--icon m-alert--outline alert alert-danger",
                                          attrs: { role: "alert" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.change_active_autho_status(
                                                  index
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                          _vm._m(10, true),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "m-alert__text" },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm._f("capitalize")(
                                                      "expired_authorization"
                                                    )
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.validate_start_date[index]
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "m-alert m-alert--icon m-alert--outline alert alert-danger",
                                          attrs: { role: "alert" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.change_active_autho_status(
                                                  index
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                          _vm._m(11, true),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "m-alert__text" },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("capitalize")(
                                                      "cannot_access_today"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.validate_blockade[index]
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "m-alert m-alert--icon m-alert--outline alert alert-danger",
                                          attrs: { role: "alert" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.change_active_autho_status(
                                                  index
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                          _vm._m(12, true),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "m-alert__text" },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm._f("capitalize")(
                                                      "person_currently_has"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("capitalize")(
                                                      _vm.blockade_type[index]
                                                    )
                                                  )
                                                )
                                              ]),
                                              _c("br"),
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm._f("capitalize")(
                                                      "contact_property_management"
                                                    )
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.validate_preauthorization === true &&
                                  _vm.active_autho[index] &&
                                  _vm.validate_training[index] === 0
                                    ? _c(
                                        "div",
                                        {
                                          key: _vm.refreshCount,
                                          staticClass:
                                            "m-alert m-alert--icon m-alert--outline alert alert-success",
                                          attrs: { role: "alert" }
                                        },
                                        [
                                          _vm._m(13, true),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "m-alert__text" },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("capitalize")(
                                                      "active_authorization"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.validate_novelty[index] &&
                                  !_vm.validate_blockade[index]
                                    ? _c(
                                        "div",
                                        {
                                          class:
                                            _vm.novelty_type[index]
                                              .is_access === 1
                                              ? "m-alert m-alert--icon m-alert--outline alert alert-info"
                                              : "m-alert m-alert--icon m-alert--outline alert alert-danger",
                                          attrs: { role: "alert" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.change_active_autho_status(
                                                  index
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                          _vm._m(14, true),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "m-alert__text" },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm._f("capitalize")(
                                                      "autho_has_novelty"
                                                    )
                                                  )
                                              ),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("capitalize")(
                                                      _vm.novelty_type[index]
                                                        .name
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-group m-form__group row"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-lg-12 pb-3" },
                                        [
                                          _c("label", [
                                            _c("b", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("capitalize")(
                                                    _vm._f("translate")(
                                                      "access_data"
                                                    )
                                                  )
                                                )
                                              )
                                            ])
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-lg-3 pb-3" },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("capitalize")(
                                                  _vm._f("translate")(
                                                    "start_date"
                                                  )
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: authorization.start_date,
                                                expression:
                                                  "authorization.start_date"
                                              }
                                            ],
                                            staticClass: "form-control m-input",
                                            attrs: {
                                              type: "text",
                                              readonly: ""
                                            },
                                            domProps: {
                                              value: authorization.start_date
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  authorization,
                                                  "start_date",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-lg-3 pb-3" },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("capitalize")(
                                                  _vm._f("translate")(
                                                    "end_date"
                                                  )
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          authorization.end_date !== ""
                                            ? _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      authorization.end_date,
                                                    expression:
                                                      "authorization.end_date"
                                                  }
                                                ],
                                                staticClass:
                                                  "form-control m-input",
                                                attrs: {
                                                  type: "text",
                                                  readonly: ""
                                                },
                                                domProps: {
                                                  value: authorization.end_date
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      authorization,
                                                      "end_date",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              })
                                            : _c("input", {
                                                staticClass:
                                                  "form-control m-input",
                                                attrs: {
                                                  type: "text",
                                                  readonly: ""
                                                },
                                                domProps: {
                                                  value: _vm._f("capitalize")(
                                                    _vm._f("translate")(
                                                      "undefined_date"
                                                    )
                                                  )
                                                }
                                              })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-lg-3 pb-3" },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("capitalize")(
                                                  _vm._f("translate")(
                                                    "start_time"
                                                  )
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  authorization.access_profile
                                                    .start_time,
                                                expression:
                                                  "authorization.access_profile.start_time"
                                              }
                                            ],
                                            staticClass: "form-control m-input",
                                            attrs: {
                                              type: "text",
                                              readonly: ""
                                            },
                                            domProps: {
                                              value:
                                                authorization.access_profile
                                                  .start_time
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  authorization.access_profile,
                                                  "start_time",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-lg-3 pb-3" },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("capitalize")(
                                                  _vm._f("translate")(
                                                    "end_time"
                                                  )
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  authorization.access_profile
                                                    .end_time,
                                                expression:
                                                  "authorization.access_profile.end_time"
                                              }
                                            ],
                                            staticClass: "form-control m-input",
                                            attrs: {
                                              type: "text",
                                              readonly: ""
                                            },
                                            domProps: {
                                              value:
                                                authorization.access_profile
                                                  .end_time
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  authorization.access_profile,
                                                  "end_time",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-lg-3 pb-2" },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("capitalize")(
                                                  _vm._f("translate")(
                                                    "access_profile"
                                                  )
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  authorization.access_profile
                                                    .name,
                                                expression:
                                                  "authorization.access_profile.name"
                                              }
                                            ],
                                            staticClass: "form-control m-input",
                                            attrs: {
                                              type: "text",
                                              readonly: ""
                                            },
                                            domProps: {
                                              value:
                                                authorization.access_profile
                                                  .name
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  authorization.access_profile,
                                                  "name",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-lg-3 pb-2" },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("capitalize")(
                                                  _vm._f("translate")(
                                                    "income_number"
                                                  )
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  authorization.access_profile
                                                    .income_number,
                                                expression:
                                                  "authorization.access_profile.income_number"
                                              }
                                            ],
                                            staticClass: "form-control m-input",
                                            attrs: {
                                              type: "text",
                                              readonly: ""
                                            },
                                            domProps: {
                                              value:
                                                authorization.access_profile
                                                  .income_number
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  authorization.access_profile,
                                                  "income_number",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-lg-3 pb-2" },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("capitalize")(
                                                  _vm._f("translate")(
                                                    "access_days"
                                                  )
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("textarea", {
                                            staticClass: "form-control m-input",
                                            staticStyle: {
                                              "margin-top": "0px",
                                              "margin-bottom": "0px",
                                              height: "65px"
                                            },
                                            attrs: {
                                              type: "text",
                                              readonly: ""
                                            },
                                            domProps: {
                                              value: _vm.autho_access_days[
                                                index
                                              ].trim()
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-lg-3 pb-2" },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("capitalize")(
                                                  _vm._f("translate")(
                                                    "authorized_control_points"
                                                  )
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("textarea", {
                                            staticClass: "form-control m-input",
                                            staticStyle: {
                                              "margin-top": "0px",
                                              "margin-bottom": "0px",
                                              height: "65px"
                                            },
                                            attrs: {
                                              type: "text",
                                              readonly: ""
                                            },
                                            domProps: {
                                              value: _vm.autho_control_points[
                                                index
                                              ].trim()
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-group m-form__group row"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-lg-3 pb-2" },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("capitalize")(
                                                  _vm._f("translate")(
                                                    "user_register"
                                                  )
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          authorization.created === null
                                            ? _c("input", {
                                                staticClass:
                                                  "form-control m-input",
                                                attrs: {
                                                  type: "text",
                                                  readonly: ""
                                                }
                                              })
                                            : _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      authorization.created
                                                        .full_name,
                                                    expression:
                                                      "authorization.created.full_name"
                                                  }
                                                ],
                                                staticClass:
                                                  "form-control m-input",
                                                attrs: {
                                                  type: "text",
                                                  readonly: ""
                                                },
                                                domProps: {
                                                  value:
                                                    authorization.created
                                                      .full_name
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      authorization.created,
                                                      "full_name",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-lg-3 pb-2" },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("capitalize")(
                                                  _vm._f("translate")(
                                                    "date_register"
                                                  )
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          authorization.created === null
                                            ? _c("input", {
                                                staticClass:
                                                  "form-control m-input",
                                                attrs: {
                                                  type: "text",
                                                  readonly: ""
                                                }
                                              })
                                            : _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      authorization.create_time,
                                                    expression:
                                                      "authorization.create_time"
                                                  }
                                                ],
                                                staticClass:
                                                  "form-control m-input",
                                                attrs: {
                                                  type: "text",
                                                  readonly: ""
                                                },
                                                domProps: {
                                                  value:
                                                    authorization.create_time
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      authorization,
                                                      "create_time",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-lg-3 pb-2" },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("capitalize")(
                                                  _vm._f("translate")(
                                                    "user_updated"
                                                  )
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          authorization.updated === null
                                            ? _c("input", {
                                                staticClass:
                                                  "form-control m-input",
                                                attrs: {
                                                  type: "text",
                                                  readonly: ""
                                                }
                                              })
                                            : _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      authorization.updated
                                                        .full_name,
                                                    expression:
                                                      "authorization.updated.full_name"
                                                  }
                                                ],
                                                staticClass:
                                                  "form-control m-input",
                                                attrs: {
                                                  type: "text",
                                                  readonly: ""
                                                },
                                                domProps: {
                                                  value:
                                                    authorization.updated
                                                      .full_name
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      authorization.updated,
                                                      "full_name",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-lg-3 pb-2" },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("capitalize")(
                                                  _vm._f("translate")(
                                                    "date_updated"
                                                  )
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          authorization.updated === null
                                            ? _c("input", {
                                                staticClass:
                                                  "form-control m-input",
                                                attrs: {
                                                  type: "text",
                                                  readonly: ""
                                                }
                                              })
                                            : _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      authorization.update_time,
                                                    expression:
                                                      "authorization.update_time"
                                                  }
                                                ],
                                                staticClass:
                                                  "form-control m-input",
                                                attrs: {
                                                  type: "text",
                                                  readonly: ""
                                                },
                                                domProps: {
                                                  value:
                                                    authorization.update_time
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      authorization,
                                                      "update_time",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-group m-form__group row"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-lg-6 pb-2" },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("capitalize")(
                                                  _vm._f("translate")(
                                                    "observations"
                                                  )
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  authorization.observations,
                                                expression:
                                                  "authorization.observations"
                                              }
                                            ],
                                            staticClass: "form-control m-input",
                                            staticStyle: {
                                              "margin-top": "0px",
                                              "margin-bottom": "0px",
                                              height: "48px"
                                            },
                                            attrs: {
                                              type: "text",
                                              readonly: ""
                                            },
                                            domProps: {
                                              value: authorization.observations
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  authorization,
                                                  "observations",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: authorization.own_fleet,
                                              expression:
                                                "authorization.own_fleet"
                                            }
                                          ],
                                          staticClass:
                                            "col-lg-6 pb-2 m-checkbox-list m-checkbox-inline-form-wizard",
                                          staticStyle: { "margin-top": "40px" }
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "m-checkbox" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      authorization.own_fleet,
                                                    expression:
                                                      "authorization.own_fleet"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "checkbox",
                                                  disabled: ""
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    authorization.own_fleet
                                                  )
                                                    ? _vm._i(
                                                        authorization.own_fleet,
                                                        null
                                                      ) > -1
                                                    : authorization.own_fleet
                                                },
                                                on: {
                                                  change: function($event) {
                                                    var $$a =
                                                        authorization.own_fleet,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            authorization,
                                                            "own_fleet",
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            authorization,
                                                            "own_fleet",
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        authorization,
                                                        "own_fleet",
                                                        $$c
                                                      )
                                                    }
                                                  }
                                                }
                                              }),
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm._f("capitalize")(
                                                      _vm._f("translate")(
                                                        "is_own_fleet"
                                                      )
                                                    )
                                                  ) +
                                                  "\n                        "
                                              ),
                                              _c("span")
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-lg-3 pb-5" }, [
                                    authorization.person_vehicles.length > 0
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "buttons-actions btn btn-primary m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill",
                                            attrs: {
                                              href: "",
                                              "data-toggle": "modal",
                                              "data-backdrop": "static",
                                              "data-keyboard": "false",
                                              "data-target": "#add_cars_modal"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.showModals(index)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-car"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "badge badge-notification"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    authorization
                                                      .person_vehicles.length
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    authorization.person_vehicles.length > 0
                                      ? _c("label", [_vm._v(" ")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    authorization.person_vehicles.length > 0
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "buttons-actions btn btn-primary m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill",
                                            attrs: {
                                              href: "",
                                              "data-toggle": "modal",
                                              "data-backdrop": "static",
                                              "data-keyboard": "false",
                                              "data-target":
                                                "#add_ownfleet_cars_modal"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.showModals(index)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-bus"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "badge badge-notification"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    authorization
                                                      .person_vehicles.length
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    authorization.person_credentials.length >
                                      0 || _vm.credential_list.length > 0
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "btn-primary buttons-actions btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill",
                                            attrs: {
                                              href: "",
                                              "data-toggle": "modal",
                                              "data-backdrop": "static",
                                              "data-keyboard": "false",
                                              "data-target":
                                                "#add_credentials_modal"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.showModals(index)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-address-card"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "badge badge-notification"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    authorization.person_credentials.filter(
                                                      function(credential) {
                                                        return (
                                                          credential.name !==
                                                          "PIN"
                                                        )
                                                      }
                                                    ).length
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    authorization.person_documents.length > 0
                                      ? _c("label", [_vm._v(" ")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    authorization.person_documents.length > 0
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "btn-primary buttons-actions btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill",
                                            attrs: {
                                              href: "",
                                              "data-toggle": "modal",
                                              "data-backdrop": "static",
                                              "data-keyboard": "false",
                                              "data-target":
                                                "#add_expiration_modal"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.showModals(index)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa fa-calendar-times-o"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "badge badge-notification"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    authorization
                                                      .person_documents.length
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      { attrs: { for: "see_acompanion" } },
                                      [_vm._v(" ")]
                                    ),
                                    _c("br")
                                  ]),
                                  _vm._v(" "),
                                  _vm.hasConfigBiometrics[index]
                                    ? _c("div", { staticClass: "pb-3" }, [
                                        _c("label", [
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("capitalize")(
                                                  _vm._f("translate")(
                                                    "biometrics"
                                                  )
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hasConfigBiometrics[index]
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "m-alert m-alert--icon m-alert--outline alert alert-info alert-biometric",
                                          attrs: { role: "alert" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "m-alert__icon_biometric"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-group m-form__group row"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-lg-12 pb-2"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "pb-3 color-title-biometric"
                                                        },
                                                        [
                                                          _vm.hasBiometrics[
                                                            index
                                                          ]
                                                            ? _c("label", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "capitalize"
                                                                      )(
                                                                        _vm._f(
                                                                          "translate"
                                                                        )(
                                                                          "update_enrollment"
                                                                        )
                                                                      )
                                                                    )
                                                                  )
                                                                ])
                                                              ])
                                                            : _c("label", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "capitalize"
                                                                      )(
                                                                        _vm._f(
                                                                          "translate"
                                                                        )(
                                                                          "new_enrollment"
                                                                        )
                                                                      )
                                                                    )
                                                                  )
                                                                ])
                                                              ])
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "tooltip",
                                                              rawName:
                                                                "v-tooltip",
                                                              value:
                                                                _vm.messageBiometricsTooltip,
                                                              expression:
                                                                "messageBiometricsTooltip"
                                                            }
                                                          ],
                                                          ref: "biocard",
                                                          refInFor: true,
                                                          staticClass:
                                                            "m-portlet__nav-link btn btn-primary btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill color-icon-biometric",
                                                          staticStyle: {
                                                            "border-radius":
                                                              "3rem"
                                                          },
                                                          attrs: {
                                                            "data-toggle":
                                                              "modal",
                                                            "data-backdrop":
                                                              "static",
                                                            "data-keyboard":
                                                              "false",
                                                            "data-target":
                                                              "#biometric_modal"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.saveLink(
                                                                _vm.url[index]
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-camera"
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  authorization.responsible_id != null
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form-group m-form__group row"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-lg-12 pb-3" },
                                            [
                                              _c("label", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("capitalize")(
                                                        _vm._f("translate")(
                                                          "visit_information"
                                                        )
                                                      )
                                                    )
                                                  )
                                                ])
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          authorization.company_origin != ""
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "col-lg-3 pb-3"
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("capitalize")(
                                                            _vm._f("translate")(
                                                              "company_origin"
                                                            )
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            authorization.company_origin,
                                                          expression:
                                                            "authorization.company_origin"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control m-input",
                                                      attrs: {
                                                        type: "text",
                                                        readonly: ""
                                                      },
                                                      domProps: {
                                                        value:
                                                          authorization.company_origin
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            authorization,
                                                            "company_origin",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          authorization.responsible_id != null
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "col-lg-3 pb-3"
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("capitalize")(
                                                            _vm._f("translate")(
                                                              "visited_person_first_name"
                                                            )
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      staticClass:
                                                        "form-control m-input",
                                                      attrs: {
                                                        type: "text",
                                                        readonly: ""
                                                      },
                                                      domProps: {
                                                        value:
                                                          authorization
                                                            .responsible
                                                            .first_name +
                                                          " " +
                                                          authorization
                                                            .responsible
                                                            .last_name
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "col-lg-3 pb-3"
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("capitalize")(
                                                            _vm._f("translate")(
                                                              "visited_person_identification_number"
                                                            )
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      staticClass:
                                                        "form-control m-input",
                                                      attrs: {
                                                        type: "text",
                                                        readonly: ""
                                                      },
                                                      domProps: {
                                                        value:
                                                          authorization
                                                            .responsible
                                                            .identification_types
                                                            .abbreviation +
                                                          " " +
                                                          authorization
                                                            .responsible
                                                            .identification_number
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      key: _vm.datatables_div,
                                      staticClass:
                                        "form-group m-form__group row"
                                    },
                                    [
                                      _vm.is_visitor[index] == 1
                                        ? _c(
                                            "div",
                                            { staticClass: "col-lg-12 pb-3" },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "see_acompanion"
                                                  }
                                                },
                                                [_vm._v(" ")]
                                              ),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-lg-9" },
                                                    [
                                                      _c("label", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "capitalize"
                                                              )(
                                                                _vm._f(
                                                                  "translate"
                                                                )(
                                                                  "companions_management"
                                                                )
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  !_vm.validate_blockade[
                                                    index
                                                  ] && _vm.active_autho[index]
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-3 text-right"
                                                        },
                                                        [
                                                          !_vm
                                                            .validate_end_date[
                                                            index
                                                          ] &&
                                                          !_vm
                                                            .validate_start_date[
                                                            index
                                                          ]
                                                            ? _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "btn btn-success m-btn m-btn--icon m-btn--wide",
                                                                  attrs: {
                                                                    href: "#",
                                                                    "data-toggle":
                                                                      "modal",
                                                                    "data-backdrop":
                                                                      "static",
                                                                    "data-keyboard":
                                                                      "false",
                                                                    "data-target":
                                                                      "#add_companion_modal"
                                                                  },
                                                                  on: {
                                                                    blur: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.focus_modal()
                                                                    },
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.preventDefault()
                                                                      return _vm.companionModal(
                                                                        index
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "la la-group"
                                                                    }),
                                                                    _vm._v(" "),
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "capitalize"
                                                                          )(
                                                                            _vm._f(
                                                                              "translate"
                                                                            )(
                                                                              "add"
                                                                            )
                                                                          )
                                                                        )
                                                                      )
                                                                    ])
                                                                  ])
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "see_acompanion"
                                                  }
                                                },
                                                [_vm._v(" ")]
                                              ),
                                              _c("br"),
                                              _vm._v(" "),
                                              _vm.companion_quantity[
                                                authorization.id
                                              ] > 0
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c("s-datatable", {
                                                        attrs: {
                                                          config:
                                                            _vm
                                                              .companion_datatable[
                                                              authorization.id
                                                            ]
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "actions",
                                                              fn: function(
                                                                props
                                                              ) {
                                                                return props.row
                                                                  .first_name
                                                                  .length > 0
                                                                  ? _c(
                                                                      "div",
                                                                      {},
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "tooltip",
                                                                                rawName:
                                                                                  "v-tooltip",
                                                                                value:
                                                                                  _vm.messageCredentialsTooltip,
                                                                                expression:
                                                                                  "messageCredentialsTooltip"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_info",
                                                                            attrs: {
                                                                              "data-toggle":
                                                                                "modal",
                                                                              "data-backdrop":
                                                                                "static",
                                                                              "data-keyboard":
                                                                                "false",
                                                                              "data-target":
                                                                                "#acompanion_credentials_modal"
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.list_companion_credential(
                                                                                  props
                                                                                    .row
                                                                                    .person_id,
                                                                                  props
                                                                                    .row
                                                                                    .company_id
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "fa fa-address-card"
                                                                              }
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "tooltip",
                                                                                rawName:
                                                                                  "v-tooltip",
                                                                                value:
                                                                                  _vm.messageDeleteTooltip,
                                                                                expression:
                                                                                  "messageDeleteTooltip"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill",
                                                                            class:
                                                                              props
                                                                                .row
                                                                                .state ==
                                                                              1
                                                                                ? "btn_delete"
                                                                                : "btn_success",
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.deleteAccompanied(
                                                                                  index,
                                                                                  props
                                                                                    .row
                                                                                    .id,
                                                                                  props
                                                                                    .row
                                                                                    .state ==
                                                                                    1
                                                                                    ? 0
                                                                                    : 1,
                                                                                  props
                                                                                    .row
                                                                                    .person_id,
                                                                                  props
                                                                                    .row
                                                                                    .identification_number,
                                                                                  authorization.id,
                                                                                  props
                                                                                    .row
                                                                                    .company_id
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "la la-trash"
                                                                              }
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "m-alert m-alert--icon m-alert--outline alert alert-info alert-background",
                                                      attrs: { role: "alert" }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "m-alert__icon"
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "la la-exclamation-circle"
                                                          }),
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "capitalize"
                                                                )(
                                                                  _vm._f(
                                                                    "translate"
                                                                  )(
                                                                    "no_companion_autho_message"
                                                                  )
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-lg-12 pb-5" },
                                        [
                                          _c("div", { staticClass: "pb-3" }, [
                                            _c("label", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("capitalize")(
                                                      _vm._f("translate")(
                                                        "property_moves"
                                                      )
                                                    )
                                                  )
                                                )
                                              ])
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _vm.moves_quantity[authorization.id] >
                                          0
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          class: [
                                                            {
                                                              "has-danger": _vm.errors.has(
                                                                "start_date"
                                                              )
                                                            },
                                                            "col-lg-2 pb-3 element-register"
                                                          ]
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              attrs: {
                                                                for:
                                                                  "start_date"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "capitalize"
                                                                  )(
                                                                    _vm._f(
                                                                      "translate"
                                                                    )(
                                                                      "start_date"
                                                                    )
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "s-date-time-picker",
                                                            {
                                                              attrs: {
                                                                id:
                                                                  "start_date",
                                                                name:
                                                                  "start_date",
                                                                options:
                                                                  _vm.config
                                                                    .start,
                                                                placeholder:
                                                                  "AAAA-MM-DD"
                                                              },
                                                              on: {
                                                                empty: function(
                                                                  $event
                                                                ) {
                                                                  _vm.start_date = $event
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.start_date,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.start_date = $$v
                                                                },
                                                                expression:
                                                                  "start_date"
                                                              }
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: _vm.errors.has(
                                                                    "start_date"
                                                                  ),
                                                                  expression:
                                                                    "errors.has(`start_date`)"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "m-form__help m--font-danger"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "start_date"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          class: [
                                                            {
                                                              "has-danger": _vm.errors.has(
                                                                "end_date"
                                                              )
                                                            },
                                                            "col-lg-2 pb-3 element-register"
                                                          ]
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              attrs: {
                                                                for: "end_date"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "capitalize"
                                                                  )(
                                                                    _vm._f(
                                                                      "translate"
                                                                    )(
                                                                      "end_date"
                                                                    )
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "s-date-time-picker",
                                                            {
                                                              attrs: {
                                                                id: "end_date",
                                                                name:
                                                                  "end_date",
                                                                options:
                                                                  _vm.config
                                                                    .end,
                                                                placeholder:
                                                                  "AAAA-MM-DD"
                                                              },
                                                              on: {
                                                                empty: function(
                                                                  $event
                                                                ) {
                                                                  _vm.end_date = $event
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.end_date,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.end_date = $$v
                                                                },
                                                                expression:
                                                                  "end_date"
                                                              }
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: _vm.errors.has(
                                                                    "end_date"
                                                                  ),
                                                                  expression:
                                                                    "errors.has(`end_date`)"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "m-form__help m--font-danger"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "end_date"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          class: [
                                                            {
                                                              "has-danger": _vm.errors.has(
                                                                "end_date"
                                                              )
                                                            },
                                                            "col-lg-2 pb-3 element-register"
                                                          ]
                                                        },
                                                        [
                                                          _c("label", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f(
                                                                  "capitalize"
                                                                )(
                                                                  _vm._f(
                                                                    "translate"
                                                                  )(
                                                                    "select_way"
                                                                  )
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.way,
                                                                  expression:
                                                                    "way"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control m_selectpicker",
                                                              attrs: {
                                                                id: "way"
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  var $$selectedVal = Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                  _vm.way = $event
                                                                    .target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "capitalize"
                                                                      )(
                                                                        "select_an_option"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm._l(
                                                                _vm.search_ways,
                                                                function(
                                                                  option,
                                                                  idx
                                                                ) {
                                                                  return _c(
                                                                    "option",
                                                                    {
                                                                      key: idx,
                                                                      domProps: {
                                                                        value:
                                                                          option.value
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "capitalize"
                                                                          )(
                                                                            _vm._f(
                                                                              "translate"
                                                                            )(
                                                                              option.name
                                                                            )
                                                                          )
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                }
                                                              )
                                                            ],
                                                            2
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          class: [
                                                            {
                                                              "has-danger": _vm.errors.has(
                                                                "end_date"
                                                              )
                                                            },
                                                            "col-lg-2 pb-3 element-register"
                                                          ]
                                                        },
                                                        [
                                                          _c("label", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f(
                                                                  "capitalize"
                                                                )(
                                                                  _vm._f(
                                                                    "translate"
                                                                  )("cp_mov")
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.control_points_movs,
                                                                  expression:
                                                                    "control_points_movs"
                                                                },
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate",
                                                                  value:
                                                                    "required",
                                                                  expression:
                                                                    "'required'"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "m_selectpicker form-control",
                                                              attrs: {
                                                                name:
                                                                  _vm.id_control_point,
                                                                id:
                                                                  _vm.id_control_point,
                                                                title: _vm._f(
                                                                  "capitalize"
                                                                )(
                                                                  _vm._f(
                                                                    "translate"
                                                                  )("cp_mov")
                                                                )
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  var $$selectedVal = Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                  _vm.control_points_movs = $event
                                                                    .target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "capitalize"
                                                                      )(
                                                                        "select_an_option"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm._l(
                                                                authorization
                                                                  .access_profile
                                                                  .control_points,
                                                                function(cp) {
                                                                  return _c(
                                                                    "option",
                                                                    {
                                                                      key:
                                                                        cp.id,
                                                                      domProps: {
                                                                        value:
                                                                          cp.control_point_id
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            cp.name
                                                                          ) +
                                                                          " "
                                                                      )
                                                                    ]
                                                                  )
                                                                }
                                                              )
                                                            ],
                                                            2
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: _vm.errors.has(
                                                                    _vm.id_control_point
                                                                  ),
                                                                  expression:
                                                                    "errors.has(id_control_point)"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "m-form__help m--font-danger"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      _vm.id_control_point
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          class: [
                                                            {
                                                              "has-danger": _vm.errors.has(
                                                                "end_date"
                                                              )
                                                            },
                                                            "col-lg-2 pb-3 element-register"
                                                          ]
                                                        },
                                                        [
                                                          _c("label", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f(
                                                                  "capitalize"
                                                                )(
                                                                  _vm._f(
                                                                    "translate"
                                                                  )(
                                                                    "select_messages"
                                                                  )
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.message,
                                                                  expression:
                                                                    "message"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control m_selectpicker",
                                                              attrs: {
                                                                id: "way"
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  var $$selectedVal = Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                  _vm.message = $event
                                                                    .target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "capitalize"
                                                                      )(
                                                                        "select_an_option"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm._l(
                                                                _vm.messages,
                                                                function(
                                                                  option,
                                                                  idx
                                                                ) {
                                                                  return _c(
                                                                    "option",
                                                                    {
                                                                      key: idx,
                                                                      domProps: {
                                                                        value:
                                                                          option.message
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          option.message
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                }
                                                              )
                                                            ],
                                                            2
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-1"
                                                        },
                                                        [
                                                          _c("label", [
                                                            _vm._v(" ")
                                                          ]),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn-success",
                                                              attrs: {
                                                                id: "btn-cancel"
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.initMovement
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "la la-search"
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("s-datatable", {
                                                    attrs: {
                                                      name: "property_moves",
                                                      config:
                                                        _vm.moves_datatable[
                                                          authorization.id
                                                        ]
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "actions",
                                                          fn: function(props) {
                                                            return _c(
                                                              "div",
                                                              {},
                                                              [
                                                                _vm.showMovPictures ===
                                                                "true"
                                                                  ? _c(
                                                                      "a",
                                                                      {
                                                                        staticClass:
                                                                          "m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_info",
                                                                        attrs: {
                                                                          title:
                                                                            _vm.messagePicturesTooltip,
                                                                          "data-toggle":
                                                                            "modal",
                                                                          "data-backdrop":
                                                                            "static",
                                                                          "data-keyboard":
                                                                            "false",
                                                                          "data-target":
                                                                            "#movement_pictures_modal"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.getMovementImages(
                                                                              props
                                                                                .row
                                                                                .id
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "fa fa-camera"
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            )
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  })
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "m-alert m-alert--icon m-alert--outline alert alert-info alert-background",
                                                  attrs: { role: "alert" }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "m-alert__icon"
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "la la-exclamation-circle"
                                                      }),
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "capitalize"
                                                            )(
                                                              _vm._f(
                                                                "translate"
                                                              )(
                                                                "no_movement_autho_message"
                                                              )
                                                            )
                                                          ) +
                                                          "\n                        "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.training_quantity > 0 &&
                                            _vm.validate_covid,
                                          expression:
                                            "(training_quantity > 0) && validate_covid"
                                        }
                                      ],
                                      key: _vm.training_div,
                                      staticClass: "col-lg-12 pb-3"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "row margen-izquierda" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-lg-6" },
                                            [
                                              _c("label", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("capitalize")(
                                                        _vm._f("translate")(
                                                          "trainings"
                                                        )
                                                      )
                                                    )
                                                  )
                                                ])
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div")
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.training_quantity > 0 &&
                                      _vm.validate_covid
                                        ? _c(
                                            "div",
                                            [
                                              _c("s-datatable", {
                                                attrs: {
                                                  name: "training_list",
                                                  config:
                                                    _vm.training_datatable[
                                                      authorization.id
                                                    ]
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "m-alert m-alert--icon m-alert--outline alert alert-info alert-background",
                                              attrs: { role: "alert" }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "m-alert__icon"
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "la la-exclamation-circle"
                                                  }),
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm._f("capitalize")(
                                                          _vm._f("translate")(
                                                            "no_training_message"
                                                          )
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                    ]
                                  )
                                ],
                                2
                              )
                            ]
                          )
                        ])
                      : _c("div", [
                          _vm.person_info.authorizations_reception.length < 2
                            ? _c("div", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm._f("translate")(
                                          "not_authorized_in_company"
                                        )
                                      )
                                    ) +
                                    "\n                " +
                                    _vm._s(_vm.setHidePersonData()) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ])
                  }),
                  0
                )
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "s-modal",
        {
          attrs: {
            id: "access_profile_modal",
            title: _vm._f("capitalize")(
              _vm._f("translate")("create_access_profile")
            )
          }
        },
        [
          _c("s-access-profile", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.modal_access_day,
                expression: "!modal_access_day"
              }
            ],
            attrs: {
              slot: "body",
              data: _vm.access_profile_view,
              create_outside: _vm.create_access_days,
              create_outside_group: true,
              view: _vm.create_access_days ? false : true
            },
            slot: "body"
          }),
          _vm._v(" "),
          _c("s-access-day", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.modal_access_day,
                expression: "modal_access_day"
              }
            ],
            attrs: {
              slot: "body",
              open_outside: true,
              data: _vm.access_day_view,
              view: _vm.create_access_days ? false : true,
              create_outside: _vm.create_access_days,
              modal: "true"
            },
            slot: "body"
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "s-modal",
        {
          attrs: {
            id: "add_companion_modal",
            title: _vm._f("capitalize")(_vm._f("translate")("add_companion"))
          }
        },
        [
          _c("s-add-companion", {
            ref: "com_mod",
            attrs: { slot: "body", data: _vm.companion },
            slot: "body"
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "s-modal",
        {
          attrs: {
            id: "add_cars_modal",
            title: _vm._f("capitalize")(_vm._f("translate")("vehicles")),
            close_header: true,
            size: "modal-sm modal-dialog-centered"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-body",
              attrs: { slot: "body" },
              slot: "body"
            },
            [
              _vm.person_info.authorizations_reception.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "m-scrollable",
                      attrs: {
                        "data-scrollbar-shown": "true",
                        "data-scrollable": "true",
                        "data-max-height": "200"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "form-group m-form__group" },
                        _vm._l(
                          _vm.person_info.authorizations_reception[
                            _vm.autho_index
                          ].person_vehicles,
                          function(car, idx) {
                            return _vm.own_fleet_vehicles.find(function(v) {
                              return v.license_plate === car.license_plate
                            }) === undefined
                              ? _c("div", { key: idx, staticClass: "row" }, [
                                  _c("div", { staticClass: "col-lg-9" }, [
                                    _c("label", { attrs: { for: "plate" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("capitalize")(
                                            _vm._f("translate")("plate")
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: car.license_plate,
                                          expression: "car.license_plate"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "",
                                          expression: "''"
                                        }
                                      ],
                                      staticClass: "form-control m-input",
                                      attrs: {
                                        type: "text",
                                        id: "plate",
                                        name: "plate",
                                        placeholder: "enter plate",
                                        readonly: ""
                                      },
                                      domProps: { value: car.license_plate },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            car,
                                            "license_plate",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ])
                                ])
                              : _vm._e()
                          }
                        ),
                        0
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.belongs_to_company
        ? _c(
            "s-modal",
            {
              attrs: {
                id: "biometric_modal",
                title: _vm._f("capitalize")(_vm._f("translate")("biometrics")),
                close_header: true,
                size: "modal-md modal-dialog-centered"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "modal-body",
                  attrs: { slot: "body" },
                  slot: "body"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "m-scrollable",
                      attrs: {
                        "data-scrollbar-shown": "true",
                        "data-scrollable": "true",
                        "data-max-height": "220"
                      }
                    },
                    [
                      _c("div", { staticClass: "form-group m-form__group" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("translate")("conditions")
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticStyle: { "text-align": "justify" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("text_conditions")
                                )
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row text-center" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-primary",
                                attrs: {
                                  href: "" + _vm.url_biometric,
                                  target: "_blank"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [_vm._v("Aceptar")]
                            )
                          ])
                        ])
                      ])
                    ]
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "s-modal",
        {
          attrs: {
            id: "add_ownfleet_cars_modal",
            title: _vm._f("capitalize")(
              _vm._f("translate")("own_fleet_vehicles")
            ),
            close_header: true,
            size: "modal-sm modal-dialog-centered"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-body",
              attrs: { slot: "body" },
              slot: "body"
            },
            [
              _vm.person_info.authorizations_reception.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "m-scrollable",
                      attrs: {
                        "data-scrollbar-shown": "true",
                        "data-scrollable": "true",
                        "data-max-height": "200"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "form-group m-form__group" },
                        _vm._l(
                          _vm.person_info.authorizations_reception[
                            _vm.autho_index
                          ].person_vehicles,
                          function(car, idx) {
                            return _vm.own_fleet_vehicles.find(function(v) {
                              return v.license_plate === car.license_plate
                            }) !== undefined
                              ? _c("div", { key: idx, staticClass: "row" }, [
                                  _c("div", { staticClass: "col-lg-9" }, [
                                    _c("label", { attrs: { for: "plate" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("capitalize")(
                                            _vm._f("translate")("plate")
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: car.license_plate,
                                          expression: "car.license_plate"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "",
                                          expression: "''"
                                        }
                                      ],
                                      staticClass: "form-control m-input",
                                      attrs: {
                                        type: "text",
                                        id: "plate",
                                        name: "plate",
                                        placeholder: "enter plate",
                                        readonly: ""
                                      },
                                      domProps: { value: car.license_plate },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            car,
                                            "license_plate",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ])
                                ])
                              : _vm._e()
                          }
                        ),
                        0
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.belongs_to_company
        ? _c(
            "s-modal",
            {
              attrs: {
                id: "add_credentials_modal",
                title: _vm._f("capitalize")(_vm._f("translate")("credentials")),
                close_header: true,
                size: "modal-sm modal-dialog-centered"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "modal-body",
                  attrs: { slot: "body" },
                  slot: "body"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "m-scrollable",
                      attrs: {
                        "data-scrollbar-shown": "true",
                        "data-scrollable": "true",
                        "data-max-height": "220"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "form-group m-form__group" },
                        _vm._l(
                          _vm.person_info.authorizations_reception[
                            _vm.autho_index
                          ].person_credentials,
                          function(auto_credential, idx) {
                            return auto_credential.name !== "PIN"
                              ? _c(
                                  "div",
                                  {
                                    key: idx,
                                    staticClass: "row card-container",
                                    staticStyle: { "margin-bottom": "25px" }
                                  },
                                  [
                                    _c("div", { staticClass: "col-lg-9" }, [
                                      _c(
                                        "div",
                                        {
                                          class: [
                                            {
                                              "has-danger": _vm.errors.has(
                                                "credential_" +
                                                  _vm.autho_index +
                                                  "_" +
                                                  idx
                                              )
                                            },
                                            "space-row-container"
                                          ]
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              attrs: {
                                                for:
                                                  "credential_" +
                                                  _vm.autho_index +
                                                  "_" +
                                                  idx
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("capitalize")(
                                                    _vm._f("translate")(
                                                      "credential"
                                                    )
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    auto_credential.credential_id,
                                                  expression:
                                                    "auto_credential.credential_id"
                                                }
                                              ],
                                              class: [
                                                "form-control",
                                                {
                                                  error: _vm.errors.has(
                                                    "credential_" +
                                                      _vm.autho_index +
                                                      "_" +
                                                      idx
                                                  )
                                                }
                                              ],
                                              attrs: {
                                                id:
                                                  "credential_" +
                                                  _vm.autho_index +
                                                  "_" +
                                                  idx,
                                                name:
                                                  "credential_" +
                                                  _vm.autho_index +
                                                  "_" +
                                                  idx,
                                                disabled: auto_credential.credential_add
                                                  ? false
                                                  : true
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.$set(
                                                    auto_credential,
                                                    "credential_id",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "option",
                                                { attrs: { value: "0" } },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm._f("capitalize")(
                                                          _vm._f("translate")(
                                                            "select_an_option"
                                                          )
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.credential_list,
                                                function(c) {
                                                  return auto_credential.credential_add &&
                                                    c.add_in_reception === 1
                                                    ? _c(
                                                        "option",
                                                        {
                                                          key: c.id,
                                                          domProps: {
                                                            value: c.id
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                c.description
                                                              ) +
                                                              "\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.credential_list,
                                                function(c) {
                                                  return !auto_credential.credential_add &&
                                                    c.add_in_reception === 0
                                                    ? _c(
                                                        "option",
                                                        {
                                                          key: c.id,
                                                          domProps: {
                                                            value: c.id
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                c.description
                                                              ) +
                                                              "\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                }
                                              )
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.errors.has(
                                                    "credential_" +
                                                      _vm.autho_index +
                                                      "_" +
                                                      idx
                                                  ),
                                                  expression:
                                                    "errors.has(`credential_${autho_index}_${idx}`)"
                                                }
                                              ],
                                              staticClass:
                                                "m-form__help m--font-danger"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "credential_" +
                                                        _vm.autho_index +
                                                        "_" +
                                                        idx
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          class: [
                                            {
                                              "has-danger": _vm.errors.has(
                                                "value_credential_" +
                                                  _vm.autho_index +
                                                  "_" +
                                                  idx
                                              )
                                            },
                                            "space-down"
                                          ]
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              attrs: {
                                                for:
                                                  "value_credential_" +
                                                  _vm.autho_index +
                                                  "_" +
                                                  idx
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("capitalize")(
                                                    _vm._f("translate")(
                                                      "value_credential"
                                                    )
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: auto_credential.value,
                                                expression:
                                                  "auto_credential.value"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value:
                                                  "required|numeric|max:15",
                                                expression:
                                                  "'required|numeric|max:15'"
                                              }
                                            ],
                                            staticClass:
                                              "form-control m-input space-down",
                                            attrs: {
                                              type: "text",
                                              id:
                                                "value_credential_" +
                                                _vm.autho_index +
                                                "_" +
                                                idx,
                                              name:
                                                "value_credential_" +
                                                _vm.autho_index +
                                                "_" +
                                                idx,
                                              "data-vv-as": "credential value",
                                              placeholder: _vm._f("capitalize")(
                                                _vm._f("translate")(
                                                  "enter_value_credential"
                                                )
                                              ),
                                              readonly: auto_credential.credential_add
                                                ? false
                                                : true
                                            },
                                            domProps: {
                                              value: auto_credential.value
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  auto_credential,
                                                  "value",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.errors.has(
                                                    "value_credential_" +
                                                      _vm.autho_index +
                                                      "_" +
                                                      idx
                                                  ),
                                                  expression:
                                                    "errors.has(`value_credential_${autho_index}_${idx}`)"
                                                }
                                              ],
                                              staticClass:
                                                "m-form__help m--font-danger"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "value_credential_" +
                                                        _vm.autho_index +
                                                        "_" +
                                                        idx
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          class: [
                                            {
                                              "has-danger": _vm.errors.has(
                                                "facility_code_" +
                                                  _vm.autho_index +
                                                  "_" +
                                                  idx
                                              )
                                            },
                                            "space-down"
                                          ]
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              attrs: {
                                                for:
                                                  "facility_code_" +
                                                  _vm.autho_index +
                                                  "_" +
                                                  idx
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("capitalize")(
                                                    _vm._f("translate")(
                                                      "facility_code"
                                                    )
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value:
                                                    _vm.require_facility ===
                                                      "true" &&
                                                    auto_credential.name ===
                                                      "magnetic"
                                                      ? "required"
                                                      : "",
                                                  expression:
                                                    "(require_facility === 'true' && auto_credential.name === 'magnetic') ? 'required' : ''"
                                                },
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    auto_credential.facility_code,
                                                  expression:
                                                    "auto_credential.facility_code"
                                                }
                                              ],
                                              class: ["form-control"],
                                              attrs: {
                                                id:
                                                  "facility_code_" +
                                                  _vm.autho_index +
                                                  "_" +
                                                  idx,
                                                name:
                                                  "facility_code_" +
                                                  _vm.autho_index +
                                                  "_" +
                                                  idx
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.$set(
                                                    auto_credential,
                                                    "facility_code",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "option",
                                                { attrs: { value: "" } },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm._f("capitalize")(
                                                          _vm._f("translate")(
                                                            "select_an_option"
                                                          )
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.list_facility_code,
                                                function(c) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      key: c.facility_code,
                                                      domProps: {
                                                        value: c.facility_code
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            c.facility_code
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.errors.has(
                                                    "facility_code_" +
                                                      _vm.autho_index +
                                                      "_" +
                                                      idx
                                                  ),
                                                  expression:
                                                    "errors.has(`facility_code_${autho_index}_${idx}`)"
                                                }
                                              ],
                                              staticClass:
                                                "m-form__help m--font-danger"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "facility_code"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: auto_credential.credential_add
                                              ? true
                                              : false,
                                            expression:
                                              "auto_credential.credential_add ? true : false"
                                          }
                                        ],
                                        staticClass:
                                          "btn-group group-credentials",
                                        attrs: {
                                          role: "group",
                                          "aria-label": "First group"
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "btn btn-danger m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill",
                                            attrs: { href: "" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                $event.preventDefault()
                                                return _vm.dropCredential(idx)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-trash"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "btn btn-primary m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill",
                                            attrs: { href: "" },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.uniqueCredential(
                                                  auto_credential,
                                                  _vm.autho_index,
                                                  auto_credential.facility_code
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-save"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          }
                        ),
                        0
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.credential_list.length > 0,
                          expression: "credential_list.length > 0"
                        }
                      ],
                      staticClass:
                        "btn btn-brand m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill",
                      attrs: { href: "" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.addCredential.apply(null, arguments)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-plus" })]
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "s-modal",
        {
          attrs: {
            id: "add_expiration_modal",
            title: _vm._f("capitalize")(_vm._f("translate")("expirations")),
            close_header: true,
            size: "modal-sm modal-dialog-centered"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-body",
              attrs: { slot: "body" },
              slot: "body"
            },
            [
              _vm.person_info.authorizations_reception.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "m-scrollable",
                      attrs: {
                        "data-scrollbar-shown": "true",
                        "data-scrollable": "true",
                        "data-max-height": "200"
                      }
                    },
                    [
                      _c("div", { staticClass: "form-group m-form__group" }, [
                        _c(
                          "div",
                          { staticClass: "form-group m-form__group row" },
                          _vm._l(
                            _vm.person_info.authorizations_reception[
                              _vm.autho_index
                            ].person_documents,
                            function(docs, k) {
                              return _c(
                                "div",
                                { key: k, staticClass: "row doc_expiration" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-lg-12",
                                      class: {
                                        "has-danger": _vm.errors.has(
                                          "expires_doc_" +
                                            _vm.autho_index +
                                            "_" +
                                            k
                                        )
                                      }
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for:
                                              "expires_doc_" +
                                              _vm.autho_index +
                                              "_" +
                                              k
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("capitalize")(
                                                _vm._f("translate")(docs.name)
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("s-date-time-picker", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value:
                                              docs.required === 1
                                                ? "required"
                                                : "",
                                            expression:
                                              "docs.required === 1 ? 'required' : ''"
                                          }
                                        ],
                                        attrs: {
                                          options: _vm.config_expiration,
                                          name:
                                            "expires_doc_" +
                                            _vm.autho_index +
                                            "_" +
                                            k,
                                          id:
                                            "expires_doc_" +
                                            _vm.autho_index +
                                            "_" +
                                            k,
                                          placeholder: "DD-MM-YYYY"
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.docExpiration(
                                              docs.id,
                                              _vm.autho_index,
                                              k,
                                              $event
                                            )
                                          }
                                        },
                                        model: {
                                          value: docs.value,
                                          callback: function($$v) {
                                            _vm.$set(docs, "value", $$v)
                                          },
                                          expression: "docs.value"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has(
                                                "expires_doc_" +
                                                  _vm.autho_index +
                                                  "_" +
                                                  k
                                              ),
                                              expression:
                                                "errors.has(`expires_doc_${autho_index}_${k}`)"
                                            }
                                          ],
                                          staticClass:
                                            "m-form__help m--font-danger"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "expires_doc_" +
                                                    _vm.autho_index +
                                                    "_" +
                                                    k
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            }
                          ),
                          0
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "s-modal",
        {
          attrs: {
            id: "acompanion_credentials_modal",
            title: _vm._f("capitalize")(
              _vm._f("translate")("acompanion_credentials")
            ),
            close_header: true,
            size: "modal-sm modal-dialog-centered"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-body",
              attrs: { slot: "body" },
              slot: "body"
            },
            [
              _vm.companion_credential.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "m-scrollable",
                      attrs: {
                        "data-scrollbar-shown": "true",
                        "data-scrollable": "true",
                        "data-max-height": "220"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "form-group m-form__group" },
                        _vm._l(_vm.companion_credential, function(
                          auto_credential,
                          idx
                        ) {
                          return _c(
                            "div",
                            {
                              key: idx,
                              staticClass: "row card-container",
                              staticStyle: { "margin-bottom": "25px" }
                            },
                            [
                              _c("div", { staticClass: "col-lg-9" }, [
                                _c(
                                  "div",
                                  {
                                    class: [
                                      {
                                        "has-danger": _vm.errors.has(
                                          "credential_" +
                                            _vm.autho_index +
                                            "_" +
                                            idx
                                        )
                                      },
                                      "space-row-container"
                                    ]
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        attrs: {
                                          for:
                                            "credential_" +
                                            _vm.autho_index +
                                            "_" +
                                            idx
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("capitalize")(
                                              _vm._f("translate")("credential")
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              auto_credential.credential_id,
                                            expression:
                                              "auto_credential.credential_id"
                                          }
                                        ],
                                        class: [
                                          "form-control",
                                          {
                                            error: _vm.errors.has(
                                              "credential_" +
                                                _vm.autho_index +
                                                "_" +
                                                idx
                                            )
                                          }
                                        ],
                                        attrs: {
                                          id:
                                            "credential_" +
                                            _vm.autho_index +
                                            "_" +
                                            idx,
                                          name:
                                            "credential_" +
                                            _vm.autho_index +
                                            "_" +
                                            idx,
                                          disabled: ""
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              auto_credential,
                                              "credential_id",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          }
                                        }
                                      },
                                      _vm._l(_vm.credential_list, function(c) {
                                        return auto_credential.credential_add &&
                                          c.add_in_reception === 1
                                          ? _c(
                                              "option",
                                              {
                                                key: c.id,
                                                domProps: { value: c.id }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(c.name) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      }),
                                      0
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has(
                                              "credential_" +
                                                _vm.autho_index +
                                                "_" +
                                                idx
                                            ),
                                            expression:
                                              "errors.has(`credential_${autho_index}_${idx}`)"
                                          }
                                        ],
                                        staticClass:
                                          "m-form__help m--font-danger"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "credential_" +
                                                  _vm.autho_index +
                                                  "_" +
                                                  idx
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    class: [
                                      {
                                        "has-danger": _vm.errors.has(
                                          "value_credential_" +
                                            _vm.autho_index +
                                            "_" +
                                            idx
                                        )
                                      },
                                      "space-down"
                                    ]
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        attrs: {
                                          for:
                                            "value_credential_" +
                                            _vm.autho_index +
                                            "_" +
                                            idx
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("capitalize")(
                                              _vm._f("translate")(
                                                "value_credential"
                                              )
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: auto_credential.value,
                                          expression: "auto_credential.value"
                                        }
                                      ],
                                      staticClass:
                                        "form-control m-input space-down",
                                      attrs: {
                                        type: "text",
                                        id:
                                          "value_credential_" +
                                          _vm.autho_index +
                                          "_" +
                                          idx,
                                        name:
                                          "value_credential_" +
                                          _vm.autho_index +
                                          "_" +
                                          idx,
                                        "data-vv-as": "credential value",
                                        placeholder: _vm._f("capitalize")(
                                          _vm._f("translate")(
                                            "enter_value_credential"
                                          )
                                        ),
                                        readonly: ""
                                      },
                                      domProps: {
                                        value: auto_credential.value
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            auto_credential,
                                            "value",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has(
                                              "value_credential_" +
                                                _vm.autho_index +
                                                "_" +
                                                idx
                                            ),
                                            expression:
                                              "errors.has(`value_credential_${autho_index}_${idx}`)"
                                          }
                                        ],
                                        staticClass:
                                          "m-form__help m--font-danger"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "value_credential_" +
                                                  _vm.autho_index +
                                                  "_" +
                                                  idx
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("br")
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "s-modal",
        {
          attrs: {
            id: "movement_pictures_modal",
            title: _vm._f("capitalize")(
              _vm._f("translate")("movement_pictures")
            ),
            close_header: true,
            size: "modal-lg modal-dialog-centered"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-body",
              attrs: { slot: "body" },
              slot: "body"
            },
            [
              _vm.movsImages.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "carousel slide",
                      attrs: {
                        id: "carouselExampleIndicators",
                        "data-ride": "carousel"
                      }
                    },
                    [
                      _c(
                        "ol",
                        { staticClass: "carousel-indicators" },
                        _vm._l(_vm.movsImages, function(img, indexLi) {
                          return _c("li", {
                            class: { active: indexLi == 0 },
                            attrs: {
                              "data-target": "#carouselExampleIndicators",
                              "data-slide-to": indexLi
                            }
                          })
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "carousel-inner" },
                        _vm._l(_vm.movsImages, function(img, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "carousel-item",
                              class: { active: index == 0 }
                            },
                            [
                              _c("img", {
                                staticClass: "d-block w-100",
                                attrs: { src: img, alt: "First slide" }
                              })
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "carousel-control-prev",
                          attrs: {
                            href: "#carouselExampleIndicators",
                            role: "button",
                            "data-slide": "prev"
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "carousel-control-prev-icon",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("Previous")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "carousel-control-next",
                          attrs: {
                            href: "#carouselExampleIndicators",
                            role: "button",
                            "data-slide": "next"
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "carousel-control-next-icon",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("Next")
                          ])
                        ]
                      )
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "alert alert-primary",
                      attrs: { role: "alert" }
                    },
                    [
                      _vm._v(
                        "\n          \t" +
                          _vm._s(
                            _vm._f("titleize")(
                              _vm._f("translate")("empty_mov_images")
                            )
                          ) +
                          "\n        "
                      )
                    ]
                  )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "m-portlet__head-icon m--hide" }, [
      _c("i", { staticClass: "la la-gear" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-alert__icon" }, [
      _c("i", { staticClass: "la la-warning" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "m-portlet__head-icon m--hide" }, [
      _c("i", { staticClass: "la la-gear" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-alert__icon" }, [
      _c("i", { staticClass: "la la-warning" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-alert__icon" }, [
      _c("i", { staticClass: "la la-warning" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-alert__icon" }, [
      _c("i", { staticClass: "la la-certificate" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-alert__icon" }, [
      _c("i", { staticClass: "la la-certificate" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-alert__icon" }, [
      _c("i", { staticClass: "la la-warning" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-alert__icon" }, [
      _c("i", { staticClass: "la la-warning" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-alert__icon" }, [
      _c("i", { staticClass: "la la-warning" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-alert__icon" }, [
      _c("i", { staticClass: "la la-warning" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-alert__icon" }, [
      _c("i", { staticClass: "la la-warning" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-alert__icon" }, [
      _c("i", { staticClass: "la la-times-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-alert__icon" }, [
      _c("i", { staticClass: "la la-check" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-alert__icon" }, [
      _c("i", { staticClass: "la la-clipboard" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-824a7a52", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-824a7a52","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/reception/Reception.vue
// module id = 838
// module chunks = 0 1 8